import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional, IsString, Matches, MaxLength, MinLength } from 'class-validator';

export class AprobarAutorizacionDto {
  @ApiProperty({ description: 'PIN del supervisor', example: '1234' })
  @IsString()
  @MinLength(4)
  @MaxLength(6)
  @Matches(/^\d{4,6}$/, { message: 'El PIN debe ser numérico de 4 a 6 dígitos' })
  pin: string;
}

export class RechazarAutorizacionDto {
  @ApiPropertyOptional({ description: 'Motivo del rechazo' })
  @IsOptional()
  @IsString()
  motivo?: string;
}
